import styled from 'styled-components/macro'

import { getToken } from '@loadsmart/loadsmart-ui/dist/theming'

export const StatusContent = styled.div`
  color: ${getToken('color-neutral-darker')};
  font-weight: 500;
  font-size: 13px;
  padding-left: 55px;
`
